import './BackgroundStatic.scss';
import React from 'react';
import { EnvironmentVariables } from '../../../helpers/constants/EnvironmentVariables';

const componentInfo = {
  name: 'BackgroundStatic',
  className: 'background-static',
  useType: 'Content',
  componentType: 'Basic',
};
const BackgroundStatic = () => (
  <div className={componentInfo.className}>
    <img src={EnvironmentVariables.OyakLogoSvg}></img>
  </div>
);

export default BackgroundStatic;
